import { render, staticRenderFns } from "./GradesChart.vue?vue&type=template&id=da54bc12"
import script from "./GradesChart.vue?vue&type=script&lang=js"
export * from "./GradesChart.vue?vue&type=script&lang=js"
import style0 from "./GradesChart.vue?vue&type=style&index=0&id=da54bc12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports